export default __webpack_public_path__ + "images/streker_sirkel_liten.png";